export default {
  getRows: (state) => state.rows,
  getRow: (state) => state.row,
  getPagination: (state) => state.pagination,
  getSearchInfo: (state) => state.searchInfo,
  getOrderBy: (state) => state.orderBy,
  getTableOptions: (state) => state.tableOptions,
  getValidations: (state) => state.validations,
  getErrors: (state) => state.errors,
  getEditDef: (state) => state.PageConst.FORM_DEF.editDef,
  getSearchDef: (state) => state.PageConst.SEARCH_DEF.inputDef,
  getTableDef: (state) => state.PageConst.LIST_DEF.tableDef
}
